import React from 'react';
import { SearchIcon } from './icons/InterfaceIcons';

export const MockTestFilters = ({ searchQuery, setSearchQuery }) => {
    return (
        <div className="sticky top-16 z-40 bg-brand-bg/80 backdrop-blur-md py-4 -my-4">
            <div className="flex justify-end">
                {/* Search */}
                <div className="relative w-full sm:w-64">
                    <SearchIcon className="absolute left-3 top-1/2 -translate-y-1/2 h-5 w-5 text-brand-text-secondary" />
                    <input
                        type="text"
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        placeholder="Search by mock name..."
                        className="w-full bg-brand-surface border border-brand-border rounded-lg pl-10 pr-4 py-2 text-sm text-brand-text-primary placeholder-brand-text-secondary focus:outline-none focus:ring-2 focus:ring-brand-primary"
                    />
                </div>
            </div>
        </div>
    );
};